import { createContext, useCallback, useContext, useState, ReactNode } from 'react';

interface ToastItem { id: number; msg: string; err?: boolean; }
interface ToastCtx { toast: (msg: string, err?: boolean) => void; }

const Ctx = createContext<ToastCtx | null>(null);

export function ToastProvider({ children }: { children: ReactNode }) {
  const [items, setItems] = useState<ToastItem[]>([]);

  const toast = useCallback((msg: string, err = false) => {
    const id = Date.now() + Math.random();
    setItems((prev) => [...prev, { id, msg, err }]);
    setTimeout(() => setItems((prev) => prev.filter((t) => t.id !== id)), 3500);
  }, []);

  return (
    <Ctx.Provider value={{ toast }}>
      {children}
      <div className="toast-host">
        {items.map((t) => (
          <div key={t.id} className={'toast' + (t.err ? ' err' : '')}>{t.msg}</div>
        ))}
      </div>
    </Ctx.Provider>
  );
}

export function useToast() {
  const ctx = useContext(Ctx);
  if (!ctx) throw new Error('useToast doit être utilisé dans <ToastProvider>');
  return ctx.toast;
}
